import PropTypes from 'prop-types';
import React from 'react';
import {
  defineMessages,
  injectIntl,
  intlShape,
  FormattedMessage,
} from 'react-intl';
import Button from 'brastrap/common/button/Button';
import Link from 'brastrap/containers/link/LinkContainer';

const messages = defineMessages({
  updateResults: {
    id: 'results-display.update-button',
    defaultMessage: 'Update results',
  },
  priceAsc: {
    id: 'product-listing.sort.price-asc',
    defaultMessage: 'Price low to high',
  },
  priceDesc: {
    id: 'product-listing.sort.price-desc',
    defaultMessage: 'Price high to low',
  },
  relevance: {
    id: 'product-listing.sort.relevance',
    defaultMessage: 'Relevance',
  },
});

/**
 * @todo This component could be refactored to support any number of filters.
 *
 * @param {Object} props
 * @returns {XML}
 * @constructor
 */
const ResultsDisplay = props => {
  const {
    intl,
    limit,
    optionsMessage,
    sortBy,
    sortId,
    sortMessage,
    total,
    sortOptions = [
      {
        label: intl.formatMessage(messages.relevance),
        value: 'default',
      },
      {
        label: intl.formatMessage(messages.priceAsc),
        value: 'price-asc',
      },
      {
        label: intl.formatMessage(messages.priceDesc),
        value: 'price-desc',
      },
    ],
    isAllReviews,
  } = props;
  const currentLimit = limit || props.showOptions[0];
  const currentSort = sortBy || sortOptions[0].value;

  return (
    <form action={props.location.pathname} method="post">
      <fieldset className="c-results-display">
        <legend className="u-hidden">
          <FormattedMessage
            id="results-display.title"
            defaultMessage="Display options"
          />
        </legend>
        <div className="c-results-display__items">
          <div className="c-results-display__item">
            <span className="c-results-display__label">
              {optionsMessage || (
                <FormattedMessage
                  id="results-display.items-per-page"
                  defaultMessage="Items per page"
                />
              )}
            </span>
            <div className="c-results-display__options">
              {props.showOptions.map((option, key) => {
                const isCurrent = `${option}` === `${currentLimit}`; // Ensure all options are strings
                const optionLabel =
                  option === 'All' && +total ? `${option} (${total})` : option;
                return isCurrent ? (
                  <strong
                    key={key}
                    className="c-results-display__option is-current"
                  >
                    {optionLabel}
                  </strong>
                ) : (
                  <Link
                    key={key}
                    id={`c-results-display__option-${option}`}
                    className="c-results-display__option"
                    href={`${props.location.pathname}?show=${option}`}
                    onClick={e => {
                      e.preventDefault();
                      props.onChange({ limit: option });
                    }}
                  >
                    {optionLabel}
                  </Link>
                );
              })}
            </div>
          </div>

          {!isAllReviews && (
            <div className="c-results-display__item">
              <label className="c-results-display__label" htmlFor={sortId}>
                {sortMessage || (
                  <FormattedMessage
                    id="results-display.sort-by"
                    defaultMessage="Sort by"
                  />
                )}
              </label>
              <div className="c-results-display__options">
                <select
                  onChange={e => {
                    e.preventDefault();
                    props.onChange({ sortBy: e.currentTarget.value, limit });
                  }}
                  value={currentSort}
                  className="c-field-select"
                  id={sortId}
                >
                  {sortOptions.map((option, key) => {
                    const optionProps = {
                      key,
                      value: option.value,
                    };

                    return <option {...optionProps}>{option.label}</option>;
                  })}
                </select>
              </div>
            </div>
          )}
        </div>

        <div className="c-results-display__actions">
          <Button
            label={props.intl.formatMessage(messages.updateResults)}
            submit
          />
        </div>
      </fieldset>
    </form>
  );
};

ResultsDisplay.propTypes = {
  limit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sortBy: PropTypes.string,
  sortId: PropTypes.string,
  total: PropTypes.number,
  intl: intlShape,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
  // Function will pass back an object containing { show: [number|string], sort: string }
  onChange: PropTypes.func.isRequired,
  showOptions: PropTypes.array,
  sortOptions: PropTypes.array,
  optionsMessage: PropTypes.string,
  sortMessage: PropTypes.string,
  isAllReviews: PropTypes.bool,
};

ResultsDisplay.defaultProps = {
  sortId: 'sort-results',
  showOptions: [24, 48, 'All'],
  location: { pathname: '/' },
  isAllReviews: false,
};

export default injectIntl(ResultsDisplay);
